module.exports = require("camelcase");;